import { render, staticRenderFns } from "./KarmaProgramAdd.vue?vue&type=template&id=9c4fced4&"
import script from "./KarmaProgramAdd.vue?vue&type=script&lang=js&"
export * from "./KarmaProgramAdd.vue?vue&type=script&lang=js&"
import style0 from "./KarmaProgramAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./KarmaProgramAdd.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports